/* Keep the theme's animated, finger-following slider in control.
   Use native touch scrolling only if that slider cannot initialise. */
const activateGalleryFallback = () => {
  document.querySelectorAll('hdt-product-media').forEach((gallery) => {
    const slider = gallery.querySelector('hdt-slider.hdt-medias-slider');
    if (!slider || slider.classList.contains('is--enabled') || gallery.dataset.ewaGalleryFallback === 'on') return;
    const viewport = slider.querySelector(':scope > .hdt-slider__viewport');
    const track = viewport?.querySelector(':scope > .hdt-slider__container');
    const slides = Array.from(track?.children || []).filter(slide => slide.matches('.hdt-slider__slide:not([hidden])'));
    if (!viewport || slides.length < 2) return;
    const controls = Array.from(document.querySelectorAll(`[aria-controls="${slider.id}"]`)).filter(el => el.matches('button'));
    const thumbs = Array.from(gallery.querySelectorAll('hdt-slider-thumb .hdt-thumbnail__media'));
    const abort = new AbortController();
    const originalStyles = new Map([viewport, track, ...slides].map(el => [el, el.getAttribute('style')]));
    const originalAria = new Map(slides.map(el => [el, el.getAttribute('aria-hidden')]));
    let active = 0;
    let frame = 0;
    const restore = () => {
      abort.abort();
      cancelAnimationFrame(frame);
      originalStyles.forEach((value, el) => value === null ? el.removeAttribute('style') : el.setAttribute('style', value));
      originalAria.forEach((value, el) => value === null ? el.removeAttribute('aria-hidden') : el.setAttribute('aria-hidden', value));
      viewport.scrollLeft = 0;
      delete gallery.dataset.ewaGalleryFallback;
    };
    // The slider API is private in this theme. Its init event/class is the
    // reliable readiness signal, including delayed initialisation.
    slider.addEventListener('init:slide', restore, { once: true, signal: abort.signal });
    Object.assign(viewport.style, { overflowX: 'auto', overflowY: 'hidden', scrollSnapType: 'x mandatory', touchAction: 'pan-x pan-y', overscrollBehaviorX: 'contain', scrollbarWidth: 'none', webkitOverflowScrolling: 'touch' });
    Object.assign(track.style, { display: 'flex', transform: 'none', gap: '0' });
    slides.forEach(slide => Object.assign(slide.style, { display: '', flex: '0 0 100%', width: '100%', minWidth: '100%', scrollSnapAlign: 'start', scrollSnapStop: 'always' }));
    const sync = () => {
      const selectedId = slides[active].getAttribute('data-media-id');
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === active ? 'false' : 'true'));
      controls.forEach(button => { button.disabled = button.name === 'previous' ? active === 0 : active === slides.length - 1; });
      thumbs.forEach(thumb => thumb.classList.toggle('is-thumb-selected', thumb.dataset.mediaId === selectedId));
    };
    const show = index => {
      active = Math.max(0, Math.min(index, slides.length - 1));
      const left = slides[active].offsetLeft - slides[0].offsetLeft;
      viewport.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      sync();
    };
    controls.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      show(active + (button.name === 'previous' ? -1 : 1));
    }, { signal: abort.signal }));
    thumbs.forEach(thumb => thumb.addEventListener('click', event => {
      const index = slides.findIndex(slide => slide.getAttribute('data-media-id') === thumb.dataset.mediaId);
      if (index < 0) return;
      event.preventDefault();
      show(index);
    }, { signal: abort.signal }));
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const delta = Math.abs(slide.offsetLeft - slides[0].offsetLeft - viewport.scrollLeft);
          if (delta < distance) { distance = delta; nearest = i; }
        });
        active = nearest;
        sync();
      });
    }, { passive: true, signal: abort.signal });
    gallery.dataset.ewaGalleryFallback = 'on';
    sync();
  });
};
window.addEventListener('load', () => window.setTimeout(activateGalleryFallback, 800));
document.addEventListener('shopify:section:load', () => window.setTimeout(activateGalleryFallback, 100));
